import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

export const EmailDirection1 = union([
    literal("inbound"),
    literal("outbound"),
]);